import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5c7bc17a&scoped=true&"
import script from "./index.ts?vue&type=script&lang=js&"
export * from "./index.ts?vue&type=script&lang=js&"
import style0 from "./index.less?vue&type=style&index=0&id=5c7bc17a&lang=less&scoped=true&"
import style1 from "./styles/common.less?vue&type=style&index=1&lang=less&"
import style2 from "./styles/stress.less?vue&type=style&index=2&lang=less&"
import style3 from "./styles/mute.less?vue&type=style&index=3&lang=less&"
import style4 from "./styles/multi-tone.less?vue&type=style&index=4&lang=less&"
import style5 from "./styles/liandu.less?vue&type=style&index=5&lang=less&"
import style6 from "./styles/localSpeed.less?vue&type=style&index=6&lang=less&"
import style7 from "./styles/multi-speaker.less?vue&type=style&index=7&lang=less&"
import style8 from "./styles/phonetics.less?vue&type=style&index=8&lang=less&"
import style9 from "./styles/alias-change.less?vue&type=style&index=9&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7bc17a",
  null
  
)

export default component.exports